import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatMessage } from "../../../translations/format-message";

interface ConfirmDialogProps {
  show: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  show,
  title = "Confirm",
  message,
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered size="sm" className="deleteTabs">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{message}</Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          {formatMessage('cancel')}
        </Button>

        <Button variant="danger" onClick={onConfirm}>
          {formatMessage('delete')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDialog;